import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ConfirmEmployeeStatusModal, EmployeeEditModal } from '../../../design-system';
import { EmployeesPage, EmployeesHeader, EmployeesBody } from './EmployeesComponents';
import { useStore } from '../../../context';
import { getDefaultRouter, showToRoles } from '../../../utils';
import { RoleGuard } from '../../../routes';

export const Employees = () => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const [totalCount, setTotalCount] = useState(0);

  if (showToRoles(['YARD_COMPANY_EMPLOYEE', 'CLIENT_DISPATCHER'], user))
    return <Navigate to={getDefaultRouter()} replace />;

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_COMPANY_VIEWER',
        'YARD_MANAGER',
        'YARD_DISPATCHER',
        'CLIENT_MANAGER',
      ]}
    >
      <RoleGuard roles={['TRADER']} isMobile negative>
        <EmployeesPage innerScroll>
          <EmployeesHeader totalCount={totalCount} />
          <EmployeesBody setTotalCount={setTotalCount} />
        </EmployeesPage>
        <ConfirmEmployeeStatusModal />
        <EmployeeEditModal />
      </RoleGuard>
    </RoleGuard>
  );
};
